<ng-container *ngIf="data">
  <picture-upload [dataId]="data.Oid"
                  [reflistName]="reflistName"
                  [requiredRoles]="requiredRoles"
                  [defaultNewImageType]="defaultNewImageType"
                  [pictureService]="propertyPicturesService">
  </picture-upload>
</ng-container>
